function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { mapKeys } from 'lodash';
import { HAS_WINDOW } from 'js-utils/feature-detection';
export var themeToCssVars = function themeToCssVars(theme) {
  return mapKeys(theme || {}, function (value, key) {
    return "--eds-".concat(key);
  });
};
export var setRootTheme = function setRootTheme(theme) {
  if (!HAS_WINDOW) {
    return;
  }

  var properties = themeToCssVars(theme);
  Object.entries(properties).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

    document.documentElement.style.setProperty(name, value);
  });
};
export var removeRootTheme = function removeRootTheme(theme) {
  if (!HAS_WINDOW) {
    return;
  }

  var properties = themeToCssVars(theme);
  Object.keys(properties).forEach(function (name) {
    document.documentElement.style.removeProperty(name);
  });
}; // In the future this will have more sophistication (EB-96195)

export var genTheme = function genTheme(baseTheme, themeOverrides) {
  return _objectSpread({}, baseTheme, themeOverrides);
};